/**
 * Global window key used to override Direct Line factory in Cypress and tests.
 * This must remain stable across runtime and test helpers.
 */
export const DIRECT_LINE_OVERRIDE_KEY = '__VA_CHATBOT_CREATE_DIRECT_LINE__';

/**
 * Replay watermark used when reconnecting to local/mock Direct Line
 * to request transcript history from the beginning.
 */
export const DIRECT_LINE_REPLAY_WATERMARK = '0';

/**
 * Event name dispatched when Direct Line indicates a connection failure and an
 * automatic token refresh should be attempted.
 */
export const DIRECT_LINE_CONNECTION_ERROR_EVENT = 'va-chatbot-connection-error';
export const DIRECT_LINE_TOKEN_EXPIRED_EVENT = 'va-chatbot-token-expired';

/**
 * Event name dispatched when Direct Line establishes a healthy connection.
 */
export const DIRECT_LINE_CONNECTION_RECOVERED_EVENT =
  'va-chatbot-connection-recovered';

/**
 * Activity event name used to initialize the backend conversation flow.
 */
export const DIRECT_LINE_START_CONVERSATION_EVENT = 'startConversation';

/**
 * Direct Line connection status values used in app/runtime checks.
 */
export const DIRECT_LINE_CONNECTION_STATUS = {
  CONNECTED: 2,
  EXPIRED_TOKEN: 3,
  FAILED_TO_CONNECT: 4,
};
